import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=de76d40a&scoped=true&"
import script from "./HistoryList.vue?vue&type=script&lang=ts&"
export * from "./HistoryList.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryList.vue?vue&type=style&index=0&id=de76d40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de76d40a",
  null
  
)

export default component.exports